<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add an Unallocated Order Detail</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Product Category*</label>
            <v-select
              required
              item-text="category"
              item-value="id"
              :options="categories"
              v-model="categoryId"
            />
          </div>

          <div class="field">
            <label class="label">Product*</label>
            <v-select
              v-if="categoryId"
              required
              item-text="name"
              item-value="id"
              :options="products"
              v-model="detail.product_master_id"
            />
            <div v-else class="has-text-grey-light">
              Please select a product category
            </div>
          </div>

          <div 
            class="field" 
            v-if="detail.product_master_id && productCategory.has_dimensions">
            <label class="label">Product Dimension*</label>
            <v-select
              v-if="detail.product_master_id"
              required
              :item-text="dimensionFn"
              item-value="id"
              :options="stockingUnits"
              v-model="detail.stocking_unit_id"
            />
            <div v-else class="has-text-grey-light">
              Please select a product
            </div>
          </div>

          <div class="field">
            <label class="label">Quantity*</label>
            <v-text-field
              required
              v-model="detail.qty_unassigned">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNew()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    orderId: {
      type: [String, Number]
    }
  },
  components: { 
    VForm,
    VSelect,
    VTextField
  },
  data() {
    return {
      categoryId: null,
      detail: {
        order_id: null,
        product_master_id: null,
        stocking_unit_id: null,
        qty_unassigned: null
      },
      dimensionFn: (stockingUnit) => {
        return `L${stockingUnit.length_in_str}" x W${stockingUnit.width_in_str}" x T${stockingUnit.thick_in_str}"`
      },
      valid: false
    }
  },
  computed: {
    ...mapState("products", ["categories", "products"]),
    productCategory() {
      return this.categories.filter(
        d => d.id == this.categoryId
      )[0];
    },
    stockingUnits() {
      return this.products.filter(
        d => d.id == this.detail.product_master_id
      )[0].stocking_units;
    }
  },
  watch: {
    categoryId(id) {
      this.detail.product_master_id = null;
      this.getProducts({ product_category_id: id });
    },
    'detail.product_master_id'(id) {
      if (id != null && !this.productCategory.has_dimensions) {
        this.detail.stocking_unit_id = this.stockingUnits[0].id;
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("order", ["addDetail"]),
    ...mapActions("products", ["getCategories", "getProducts"]),
    initialize() {
      if (this.categories.length == 0) {
        this.getCategories({ per_page: 100 });
      }
    },
    addNew() {
      this.detail.order_id = this.orderId;
      this.addDetail(this.detail).then(() => {
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
